module.exports = __webpack_public_path__ + "assets/img/CUA-Social-Static-Ad.f2f2a563.webp";